var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-infomaion-detail",class:{'mobile': _vm._isMobile}},[_c('div',{staticClass:"infomaion-detail-wrap",class:{'pc': !_vm._isMobile}},[_c('cmpBanner',{attrs:{"bannerType":"1"}}),_c('div',{staticClass:"g-wrap"},[_c('div',{staticClass:"g-content"},[_c('cmpDetail',{attrs:{"detailData":_vm.detailData}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }